import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import client, { apiError } from '../api/client';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: params.get('email') || '', code: '', newPassword: '',
  });
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setInfo(''); setLoading(true);
    try {
      const { data } = await client.post('/auth/reset-password', form);
      setInfo(data.message);
      setTimeout(() => navigate('/login'), 900);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-narrow" style={{ marginTop: 48 }}>
      <div className="card card-pad-lg">
        <h1>Set a new password</h1>
        <p className="muted small">Enter the code we emailed and your new password.</p>
        <div className="divider" />
        {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}
        {info && <div className="alert alert-ok" style={{ marginBottom: 14 }}>{info}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label>Email</label>
            <input type="email" value={form.email} onChange={set('email')} required />
          </div>
          <div className="field">
            <label>Reset code</label>
            <input value={form.code} onChange={set('code')} maxLength={6} inputMode="numeric" required />
          </div>
          <div className="field">
            <label>New password</label>
            <input type="password" value={form.newPassword} onChange={set('newPassword')} minLength={8} required />
            <div className="hint">At least 8 characters.</div>
          </div>
          <button className="btn btn-primary btn-block" style={{ marginTop: 18 }} disabled={loading}>
            {loading ? <span className="spinner" /> : 'Update password'}
          </button>
        </form>
        <p className="small center" style={{ marginTop: 16 }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
